import styled from '@emotion/styled'
import { PharmacIcon, PharmacIconProps } from '@pharmac/ui'
import { CategoryListItemCategory, CategoryListItemLabelButton, CategoryListItemRoot } from '.'

type ExtranetCategoryListButtonProps = {
  onClick: () => void
  label: string
  labelEn?: string
  labelSv?: string
  icon?: PharmacIconProps['icon']
  isActive?: boolean,
  disabled?: boolean
}

const ItemIcon = styled.div<{ isDisabled?: boolean }>`
  margin-left: auto;
  width: 25px;

  svg {
    color: ${ (p) => p.isDisabled ? 'var(--color-accent-4)' : 'var(--color-accent-8)' };
    transform: translateY(10%);
  }
`

export const ExtranetCategoryListButton = ({
  onClick,
  label,
  labelEn,
  labelSv,
  icon,
  isActive,
  disabled
}: ExtranetCategoryListButtonProps) => {
  return (
    <CategoryListItemRoot isDisabled={!!disabled} style={{ background: isActive ? '#f3e9f4' : 'var(--color-white)' }}>
      <CategoryListItemCategory>
        <CategoryListItemLabelButton disabled={!!disabled} onClick={onClick}>{label}</CategoryListItemLabelButton>
        {!!icon && (
          <ItemIcon isDisabled={!!disabled}>
            <PharmacIcon
              size="24px"
              icon={icon}
            />
          </ItemIcon>
        )}
      </CategoryListItemCategory>
      {labelEn && labelSv && (
        <>
          <CategoryListItemCategory>
            <CategoryListItemLabelButton disabled={!!disabled} onClick={onClick}>
              EN: {labelEn}
            </CategoryListItemLabelButton>
          </CategoryListItemCategory>
          <CategoryListItemCategory>
            <CategoryListItemLabelButton disabled={!!disabled} onClick={onClick}>
              SV: {labelSv}
            </CategoryListItemLabelButton>
          </CategoryListItemCategory>
        </>
      )}
    </CategoryListItemRoot>
  )
}
